import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { get as _get } from 'lodash'

const env =
  process.env.NODE_ENV === 'production' ? process.env.NODE_ENV : 'development'

const sentryDsn = process.env.SENTRY_DSN
const sentryRelease = process.env.SENTRY_RELEASE

const SANITIZE_KEY_PATTERNS = [/address/i, /email/i, /^name$/i, /^zip/i]

const SANITIZING_VALUE = '********'

// @ts-ignore
function isObject(value) {
  return value && typeof value === 'object' && value.constructor === Object
}

// @ts-ignore
function sanitizePropsData(propsData) {
  if (!isObject(propsData) && !Array.isArray(propsData)) return

  Object.keys(propsData).forEach(key => {
    if (isObject(propsData[key]) || Array.isArray(propsData[key])) {
      return sanitizePropsData(propsData[key])
    } else if (!SANITIZE_KEY_PATTERNS.every(pattern => !pattern.test(key))) {
      propsData[key] = SANITIZING_VALUE
    }
  })
}

const options: Sentry.BrowserOptions = {
  dsn: sentryDsn,
  environment: env,
  denyUrls: [
    /yimg/i,
    /yjtag/i,
    /yahoo/i,
    /googletagmanager/i,
    /analytics.raksul.com/i,
    /google/i,
    /karte/i,
    /zendesk/i,
    /a8/i,
    /valuecommerce/i
  ],
  ignoreErrors: [
    /Can\'t find variable: Intl/i,
    /Can\'t find variable: tracker/,
    'tracker is undefined',
    'tracker is not defined',
    'tracker.track is not a function',
    'tracker.init is not a function',
    'tracker.view is not a function'
  ],
  sampleRate: 0.5, // Send 50% of events
  integrations: [
    new Integrations.Vue({
      Vue,
      attachProps: true
    })
  ],
  beforeSend(event) {
    const propsData = _get(event, 'extra.propsData')

    // 個人情報に関わるデータを隠す
    if (propsData) {
      sanitizePropsData(propsData)
    }

    return event
  }
}

if (sentryRelease) {
  options['release'] = sentryRelease
}

Sentry.init(options)
